<p>
  Tip: You can manually move the pin for exact location. The Address will automatically update based upon pin location.
</p>

<form [formGroup]="uomFormGroup">
  <div class="product-detail-container">
    <div class="product-details-left">
      <h6>Select UOM</h6>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>UOM</mat-label>
        <mat-select
          formControlName="UOM"
          [(ngModel)]="selectedUOMCategory"
          (selectionChange)="getSelectedUOM()"
          required
        >
          <mat-option
            *ngFor="let category of UOMCategoryList"
            [value]="category"
          >
            {{ category.name }}
          </mat-option>
        </mat-select>
        <mat-hint>Required form labels ends with an *</mat-hint>
        <mat-error *ngIf="uomFormGroup.get('UOM')?.hasError('required')">
          UOM is Required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="product-details-right">
      <h6>How will you sell this product</h6>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Measurement</mat-label>
        <mat-select
          formControlName="Measurement"
          [(ngModel)]="selectedUOMSubCategory"
          (selectionChange)="onMeasurementChange()"
          required
        >
          <mat-option
            *ngFor="let subCategory of UOMSubCategoryList"
            [value]="subCategory"
          >
            {{ subCategory.name }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="uomFormGroup.get('Measurement')?.hasError('required')"
        >
          Measurement is Required
        </mat-error>
      </mat-form-field>
    </div>

    <div
      class="product-details-right"
      *ngIf="
        selectedUOMCategory?.name !== null &&
        selectedUOMCategory?.name !== undefined &&
        selectedUOMCategory?.name !== 'Units'
      "
    >
      <h6>How many units does it contain</h6>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Units</mat-label>
        <input matInput formControlName="Units" (input)="onUnitsChange()" appCurrencyDecimal />
        <mat-error *ngIf="uomFormGroup.get('Units')?.hasError('required')">
          Units is Required
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>

<!-- UOM Display Section -->
<div class="uom-container" *ngIf="uomFormGroup.valid && (selectedUOMCategory || selectedUOMSubCategory || uomFormGroup.get('Units')?.value)">
  <div class="uom-section">
    <div class="uom-value">{{ selectedUOMCategory?.name || uomFormGroup.get('UOM')?.value || 'Not selected' }}</div>
    <div class="uom-label">Units of Measure</div>
  </div>
  
  <div class="uom-section">
    <div class="uom-value">{{ selectedUOMSubCategory?.name || uomFormGroup.get('Measurement')?.value || 'Not selected' }}</div>
    <div class="uom-label">Measurement</div>
  </div>
  
  <div class="uom-section" *ngIf="uomFormGroup.get('Units')?.value && uomFormGroup.get('Units')?.value > 0">
    <div class="uom-value">{{ uomFormGroup.get('Units')?.value || 0 }}</div>
    <div class="uom-label">How many units</div>
  </div>
</div>
